/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./previewDbTiles.vue?vue&type=template&id=879f10b6&scoped=true"
import script from "./previewDbTiles.vue?vue&type=script&lang=js"
export * from "./previewDbTiles.vue?vue&type=script&lang=js"
import style0 from "./previewDbTiles.vue?vue&type=style&index=0&id=879f10b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "879f10b6",
  null
  
)

export default component.exports